module.exports = __webpack_public_path__ + "static/media/logo-green.ce4e5f89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kiffgo/logo-green.svg
// module id = 81
// module chunks = 0